import { format } from "date-fns-tz";
import { BrazilDate } from "../../../../utils/BrazilDate";

export function formatTvHoraIso(iso: string | undefined): string {
  if (!iso?.trim()) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const timezone = BrazilDate.getTimezone();
  return format(d, "HH:mm", { timeZone: timezone });
}
